import React, { Component } from 'react';
import Datetime from 'react-datetime'

class DateTimeBootstrap extends Component {

  constructor(props) {
    super(props);

    this.onChangeWrapper = this.onChangeWrapper.bind(this);
  }

  onChangeWrapper(val, onChange) {

    return onChange && onChange({
      target: {
        type: 'datetime',
        value: val,
        name: this.props.name
      }
    });
  }


  render() {

    let cloneProps = Object.assign({}, this.props);
    let inputProps = cloneProps.inputProps || {};
    inputProps.className = "form-control";
    cloneProps.inputProps = inputProps;

    let onChange = cloneProps.onChange;
    delete cloneProps.onChange;

    if (cloneProps.valid)
      inputProps.className = inputProps.className + " is-valid";

    if (cloneProps.invalid)
      inputProps.className = inputProps.className + " is-invalid";

    return <Datetime {...cloneProps} onChange={e => this.onChangeWrapper(e, onChange)} />
  }
}

export default DateTimeBootstrap;
